<footer class="footer">
  <div class="flex justify-content-between">
    <img src="assets/icons/logo-white.svg" alt="Genetics Logo" [width]="120" />
    <nav class="align-items-center flex">
      <ul class="align-items-center flex">
        <li class="mr-4">
          <a [routerLink]="['/static-pages/privacy-policy']" target="_blank">{{
            'Footer.PrivacyPolicy' | translate
          }}</a>
        </li>
        <li class="mr-4">
          <a [routerLink]="['/static-pages/legal-notice']" target="_blank">{{ 'Footer.LegalNotice' | translate }}</a>
        </li>
        <li class="mr-4">
          <a [routerLink]="['/static-pages/terms-and-conditions']" target="_blank">{{
            'Footer.TermsAndCondition' | translate
          }}</a>
        </li>
        <li class="mr-4">
          <a [routerLink]="['/static-pages/cookie-policy']" target="_blank">{{ 'Footer.CookiePolicy' | translate }}</a>
        </li>
        @if (isActiveAccount) {
          <li class="mr-4">
            <a [routerLink]="['/static-pages/howto']" target="_blank">{{ 'Footer.HowToOrder' | translate }}</a>
          </li>
        }
        <li class="mr-4">
          <a [routerLink]="['/static-pages/contact']" target="_blank">{{ 'Footer.Contact' | translate }}</a>
        </li>
        <li class="mr-4">
          <app-language-selector />
        </li>
      </ul>
    </nav>
  </div>
  <div class="w-full flex justify-content-center">
    <span class="copyright">{{ copyrightText }} </span>
  </div>
</footer>
